import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage1Avaleht from "./pages/Webpage1Avaleht";
import Webpage4Peolauad_ja___ritused from "./pages/Webpage4Peolauad_ja___ritused";

var baseURL = 'https://helenimaja.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiMTM3YzlhMzBkMzE5NmRkYWQ1YjVkY2I5NjYyMzA5NDhmMTk3NjU2YWRmMTdiMjQxY2ZmOTdlYjEwOWNiNDU0MTk2ZmQ1ZDM5MTZjMWQxOTUiLCJpYXQiOjE3NTEyOTk4NDEuOTkxNDksIm5iZiI6MTc1MTI5OTg0MS45OTE0OTcsImV4cCI6MTc1MTM4NjI0MS45ODYzMzMsInN1YiI6IjY2Iiwic2NvcGVzIjpbXX0.BGfG27CGvVWDzE3l8u4y9IkTjxx_bL3EZAuZO9mpuVeldivfIkzuTOcIVcZ_6Nqndkd8-MDdZuQFQ9UuLCbB0ToV-FK2jytWghqRMrh2q1kG62AdLd2r6clhQDtlQ4L_gN3xHzHtNKS1jO993HbR4coMPXL5W0sMsDqDNSw6PaAEZdTdiYg0Gwla-EhnjvNAdbhjz9OjXdR5GeEulX-5rdrJpYq77zymOTnZ2sO5600lhZJihCfz-cG1G4ZX4mubmSv5UtA1qeP6wVksNojsuOSWbDCI1ZORMZly5_cr7EVgeeg4_yvfwR9EgUfO1qVxGO-ZqzlOCDJazlgjVkQhcLTPw1Luk1sQdSaODtETUa8m4GOB2f4o_aUUoYqm8bbK3iLe9bsmEqpSCvUImAvi3zqZzfA3W55VF7x1bGWii3V5J1Wo_ZcdmOb9W9_eFELDw_5u3OsIHTk4rIO5ro4V_RjUk3h03LJnGCzd3q4JxdYYpXp6igXXCGiWqIBhSa_QA4DBTLdIA2GMfmfwX8Mbxu_KUc7xDL9Y2zOUuKCzktqFzsRCXuWIydNt1jnqdCxykbUf9XQiPoXiZSxuhSbrcjVjbZlCi4oCgAArW7g6qNcrwNMB2ZzcuLKoZOgJVE_mjTXEnbDzhwEAkYlMZyKAjauRAWUBnRLTzBLQs_o1GVg',
    'Access-api-key': "eyJpdiI6IkhKNDJMYmw2TFplYlkrS0d6dG5IeEE9PSIsInZhbHVlIjoidHJidnhOb1BjenpOeWNsOU9mN214dz09IiwibWFjIjoiMGE2MmRlNDc5OTZhNGE4YTkwYjA4OWFlMWMyYjg4OGZmY2NmZWFkMWVlMzNiMzEwZGIxZDU1M2ZiYzBhNWY4NiIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IlhaWkdNTktPdkVlSDBVYWJHTUZCYUE9PSIsInZhbHVlIjoiZkxDQ2lWK0tjWW92ZXVNZFI1UUxnZz09IiwibWFjIjoiYjBkOTgzMzU2YjU0ZDM0MzBkMTRlN2NiNzAzNjEwOWYzNDIyZjc2ZGY0MTY3MGRjNWQwNjcwMDJlNzFjM2UwZCIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: ""
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage1Avaleht />} exact />;
                                                                    <Route path="/et/peolauad" element={<Webpage4Peolauad_ja___ritused />} exact />;
                                                                
                                                                <Route path="*" element={<Webpage1Avaleht />} exact />;
                                        </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}